import { useState } from 'react';

import MoreVertIcon from '@mui/icons-material/MoreVert';
import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { useNotify } from 'react-admin';
import { IconButton } from 'shared/mui/IconButtons';
import { MenuItem } from 'shared/mui/MenuItem/MenuItem';
import { useChangeViewedStatus } from 'shared/widgets/Notification/hooks/useChangeViewedStatus';
import { Notification } from 'types/embedded/notification';

import { NotificationPopperMenu } from './NotificationPopperMenu.styled';

type NotificationPopperMenuButtonProps = {
  notifications?: Notification[];
  onSuccess: () => void;
};

export const NotificationPopperMenuButton = ({
  notifications,
  onSuccess,
}: NotificationPopperMenuButtonProps): JSX.Element => {
  const translate = useTypedTranslate();

  const [anchorEl, setAnchorEl] = useState<Element | null>(null);

  const notify = useNotify();

  const { changeViewedStatus } = useChangeViewedStatus({
    onSuccess,
    onError: (error) => {
      notify(error.data?.errors[0]?.title, { type: 'error' });
    },
  });

  const handleClick = (event: React.MouseEvent<Element>): void => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (): void => {
    setAnchorEl(null);
  };
  const ids = notifications?.map((notification) => notification.id);

  return (
    <>
      <IconButton onClick={handleClick}>
        <MoreVertIcon />
      </IconButton>
      <NotificationPopperMenu
        anchorEl={anchorEl}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        disableScrollLock
        onClose={handleClose}
        open={!!anchorEl}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <MenuItem onClick={() => changeViewedStatus(ids || [])}>
          {translate('app.notificationPopper.checkAll')}
        </MenuItem>
      </NotificationPopperMenu>
    </>
  );
};
